import React from 'react'

export const InfoCircleIcon = ({ color = '#AC0AE8', ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
    {...props}
  >
    <path
      fill={color}
      d='M8 .25C3.719.25.25 3.75.25 8A7.749 7.749 0 008 15.75c4.25 0 7.75-3.469 7.75-7.75 0-4.25-3.5-7.75-7.75-7.75zm0 14A6.228 6.228 0 011.75 8 6.248 6.248 0 018 1.75c3.438 0 6.25 2.813 6.25 6.25A6.248 6.248 0 018 14.25zM8 3.687A1.3 1.3 0 006.687 5c0 .75.563 1.313 1.313 1.313A1.3 1.3 0 009.313 5 1.32 1.32 0 008 3.687zm1.75 7.938v-.75a.403.403 0 00-.375-.375H9V7.375A.403.403 0 008.625 7h-2a.38.38 0 00-.375.375v.75c0 .219.156.375.375.375H7v2h-.375a.38.38 0 00-.375.375v.75c0 .219.156.375.375.375h2.75a.38.38 0 00.375-.375z'
    />
  </svg>
)
